const cronParser = require('cron-parser');

export const getCronNextDates = (cronObject, limit = 5, finalDate) => {
    let dates = [];
    let cronInterval = cronParser.parseExpression(cronObject.minute + ' ' + cronObject.hour + ' '
        + cronObject.day_of_month + ' ' + cronObject.month_of_year + ' ' + cronObject.day_of_week);

    for (let i = 0; i < limit; i++) {
        dates.push(new Date(cronInterval.next().toString()));
    }

    if (finalDate) { dates = dates.filter(item => item <= finalDate); };

    return dates;
}